export const i18n = {
	bestBetTitle: {
		en: 'Best Bets for',
		es: 'Mejores resultados para',
	},
	definitionTitle: {
		en: 'Definition',
		es: 'Definición',
	},
	errorPageText: {
		en: 'An error occurred. Please try again later.',
		es: 'Se produjo un error. Por favor, vuelva a intentar más tarde.',
	},
	hideFullDefinition: {
		en: 'Hide full definition',
		es: 'Ocultar toda la definición',
	},
	moreInfoOnDictionaryPage: {
		en: 'More information on dictionary page',
		es: 'Más información',
	},
	nciSearchResults: {
		en: 'NCI Search Results',
		es: 'Resultados',
	},
	noResultsFoundFor: {
		en: '0 results found for',
		es: 'No hay resultados',
	},
	pageNotFoundTitle: {
		en: 'Page Not Found',
		es: 'No se encontró la página',
	},
	pleaseCheckSpellingOrTryAnotherSearch: {
		en: 'Please check your spelling or try another search using a different word.',
		es: 'Revise si hay errores en el texto ingresado o intente otra búsqueda.',
	},
	resultsFor: {
		en: 'Results for',
		es: 'Resultados para',
	},
	showFullDefinition: {
		en: 'Show full definition',
		es: 'Mostrar toda la definición',
	},
	results: {
		en: 'Results',
		es: 'Resultados',
	},
	for: {
		en: 'for',
		es: 'para',
	},
	of: {
		en: 'of',
		es: 'de',
	},
	search: {
		en: 'Search',
		es: 'Buscar',
	},
	video: {
		en: 'Video',
		es: 'Video',
	},
	infographic: {
		en: 'Infographic',
		es: 'Infografía',
	},
	newSearch: {
		en: 'New Search',
		es: 'Nueva búsqueda',
	},
	searchWithin: {
		en: 'Search Within',
		es: 'Búsqueda dentro de los resultados',
	},
	enterKeywordsOrPhrases: {
		en: 'Enter keywords or phrases',
		es: 'Ingrese palabras clave o frases',
	},
	previous: {
		en: 'Previous',
		es: 'Anterior',
	},
	next: {
		en: 'Next',
		es: 'Siguiente',
	},
	show: {
		en: 'Show',
		es: 'Mostrar',
	},
	resultsPerPage: {
		en: 'results per page',
		es: 'resultados por página',
	},
	goToPage: {
		en: 'Go to Page',
		es: 'Ir a la Página',
	},
};
